import { createSelector } from '@ngrx/store';

import { getAppDomainState } from 'src/app/modules/ngrx-store/selectors';
import { State } from 'src/app/modules/ngrx-store/terms-and-conditions/terms-and-conditions.reducer';

export const getTermsAndConditions = createSelector(
	getAppDomainState,
	(state: State) => state.termsAndConditions
);

export const getLoadTermsAndConditionsPending = createSelector(
	getAppDomainState,
	(state: State) => state.loadTermsAndConditionsPending
);

export const getLoadTermsAndConditionsSuccess = createSelector(
	getAppDomainState,
	(state: State) => state.loadTermsAndConditionsSuccess
);

export const getLoadTermsAndConditionsFailure = createSelector(
	getAppDomainState,
	(state: State) => state.loadTermsAndConditionsFailure
);

export const getAcknowledgeTermsAndConditionsPending = createSelector(
	getAppDomainState,
	(state: State) => state.acknowledgeTermsAndConditionsPending
);

export const getAcknowledgeTermsAndConditionsSuccess = createSelector(
	getAppDomainState,
	(state: State) => state.acknowledgeTermsAndConditionsSuccess
);

export const getAcknowledgeTermsAndConditionsFailure = createSelector(
	getAppDomainState,
	(state: State) => state.acknowledgeTermsAndConditionsFailure
);